import React from "react";
import { useTranslation } from "react-i18next";
import { CalendarDays, CheckCircle2, XCircle, Clock } from "lucide-react";
import { Card, CardContent } from "../ui/card";

const CalendarStatsCards = ({ scheduleData }) => {
  const { t } = useTranslation();
  if (!scheduleData) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <CalendarDays className="h-8 w-8 text-blue-500" />
            <div>
              <p className="text-2xl font-bold">{scheduleData.total_days}</p>
              <p className="text-xs text-muted-foreground">{t("planning.calendarView.stats.totalDays")}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <CheckCircle2 className="h-8 w-8 text-green-500" />
            <div>
              <p className="text-2xl font-bold">{scheduleData.working_days}</p>
              <p className="text-xs text-muted-foreground">{t("planning.calendarView.stats.workingDays")}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <XCircle className="h-8 w-8 text-gray-400" />
            <div>
              <p className="text-2xl font-bold">{scheduleData.rest_days}</p>
              <p className="text-xs text-muted-foreground">{t("planning.calendarView.stats.restDays")}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <Clock className="h-8 w-8 text-indigo-500" />
            <div>
              <p className="text-2xl font-bold">{scheduleData.total_hours_expected}</p>
              <p className="text-xs text-muted-foreground">{t("planning.calendarView.stats.expectedHours")}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CalendarStatsCards;
